import React from 'react'
import { useGetEventResultsQuery } from '../../api/resultsApi'
import { EventResultsComponent } from './EventResultsComponent'
import { EventResultsProps } from '../../utils/types'

export function UnlinkedEventResults(props: EventResultsProps) {
  const athlinksEventId = props.eventResultsFilters.date
  const eventCourseId = props.eventResultsFilters.course
  const divisionId = props.eventResultsFilters.division
  const intervalId = props.eventResultsFilters.split
  const from = (props.page || props.eventResults.args.fro || 0) * props.eventResults.args.limit
  const limit = props.eventResults.args.limit
  const { data: eventResults, isFetching, refetch, isError } = useGetEventResultsQuery(
    {
      athlinksEventId,
      eventCourseId,
      divisionId,
      intervalId,
      from,
      limit,
    }
  )
  return (
    <>
      <EventResultsComponent
        {...props}
        fetchEventResultsError={isError}
        eventResults={{ data: eventResults || [] }}
        isFetchingEventResults={isFetching}
        refetch={refetch}
        useSse={true}
      />
    </>
  )
}
